import React, { Fragment } from "react";
import { connect } from "react-redux";
import { any, func } from "prop-types";
import moment from "moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import { postWoodlandForms } from "../../redux/actions/woodlandActions";
import {
  useForm,
  determineRadioAnswers,
} from "../../common/FormCreator/helpers";

const ManualHandling = ({ appData, postWoodlandFormsFunc }) => {
  const initialState = {
    Group1: {
      title:
        "What should be considered when carrying out a manual handling assessment?",
      type: "radio",
      radioOptions: [
        "Load, individual, task and environment",
        "Load, age, environment, height",
        "How many staff are employed",
        "Nothing",
      ],
      mandatory: true,
    },
    Group2: {
      title:
        "Which of these injuries are associated with poor manual handling?",
      type: "radio",
      radioOptions: [
        "Spinal/nerve injury",
        "Muscle/ligament damage",
        "Hernias",
        "All of the above",
      ],
      mandatory: true,
    },
    Group3: {
      title: "What is the correct technique for lifting?",
      type: "radio",
      radioOptions: [
        "Knees bent, back bent, feet together",
        "It depends on what you are carrying",
        "Always ask for help",
        "Knees bent, back straight, feet apart",
      ],
      mandatory: true,
    },
    Group4: {
      title: "What can you do to reduce a heavy load?",
      type: "radio",
      radioOptions: [
        "Drag it",
        "Push it",
        "Ask for help",
        "Run quickly with it",
      ],
      mandatory: true,
    },
    Group5: {
      title:
        "What can you do if you feel uncomfortable about lifting something?",
      type: "radio",
      radioOptions: [
        "Ask for help",
        "Tell your Manager",
        "Do not lift it",
        "All of the above",
      ],
      mandatory: true,
    },
  };

  const [fields, setField] = useForm(initialState);
  const woodland = appData.woodlandGroupOnboarding;
  const submitted = woodland && woodland.manualHandling;
  const incidentReporting = woodland && woodland.incidentReporting;
  const fireSafety = woodland && woodland.fireSafety;

  const redirectBack = () => {
    history.push("/profile/edit/woodland-group-onboarding");
  };

  const handleSubmit = () => {
    const answers = determineRadioAnswers(fields);
    postWoodlandFormsFunc("manualHandling", {
      ...answers,
      date: moment().toISOString(),
    });
    if (incidentReporting && fireSafety) {
      postWoodlandFormsFunc("submit", {
        name: `${appData.firstName} ${appData.lastName}`,
        ...appData.woodlandGroupOnboarding.fireSafety,
        ...appData.woodlandGroupOnboarding.incidentReporting,
        ...answers,
        date: moment().toISOString(),
      });
    }
    redirectBack();
  };

  return (
    <>
      {submitted ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={"Manual Handling"}
          helper={""}
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"woodlandBranch"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};

ManualHandling.propTypes = {
  appData: any,
  postWoodlandFormsFunc: func,
};

const mapDispatchToProps = {
  postWoodlandFormsFunc: postWoodlandForms,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(ManualHandling);
